export default "__VITE_ASSET__CZAY1BnM__"